import { UnableToLoad } from "@/components/utils/helpers/Loading"
import PropTypes from "prop-types"
import React from "react"

const propTypes = {
  children: PropTypes.node.isRequired,
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props
    if (hasError) {
      // You can render any custom fallback UI
      return <UnableToLoad />
    }

    return children
  }
}

ErrorBoundary.propTypes = propTypes

export default ErrorBoundary
